import Vue from 'vue'
import Router from 'vue-router'
import routes from './main'
import faqData from '@/data/faq.json'
import { FAQ_SCENES, FaqData } from '@/types/faq'
import { createFaqPageSchema, filterFaqGroupsByScene } from '@/utils/faq'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// 20231119 update
const titles = {
  home: '香港餐飲業首選！PinMe POS-智慧雲端餐廳系統｜提升營運效率、省成本、做更多生意',
  snacks: 'PinMe餐飲POS，飲品店/咖啡店/快餐店/外賣店all in one餐廳系統',
  restaurant: 'PinMe餐飲POS，茶餐廳/冰室/西餐/酒樓/中菜館all in one餐廳系統',
  pasta: 'PinMe餐飲POS，車仔麵/米線店/中式粉面店all in one餐廳系統',
  foodcourt: 'PinMe餐飲POS，Foodcourt 餐飲大時代all in one餐廳系統',
  takeaway: 'PinMe餐飲POS，雲端廚房/虛擬餐廳all in one系統',
  deliveryPlatform: '外賣平台訂單整合｜一部POS集中管理｜PinMe POS',
  member: '餐廳會員管理系統｜電子印花、優惠券與會員價｜PinMe POS',
  discount: '餐廳優惠券與營銷工具｜折扣券、兌換券管理｜PinMe POS',
  systemKit: 'PinMe POS 功能模組完整介紹｜點餐、外賣整合、會員CRM、Kiosk｜香港餐飲管理系統',
  queue: '香港餐廳排隊系統「等味」｜網上取號與叫號管理｜PinMe POS',
  bigScreen: '餐廳取餐叫號大屏幕｜訂單製作狀態即時顯示｜PinMe POS',
  miniProgram: '餐廳小程式點餐｜WeChat與Alipay小程式｜PinMe POS',
  newUi: '餐廳手機點餐介面｜品牌自訂與電子會員卡｜PinMe POS',
  kiosk: '餐廳自助點餐Kiosk｜自助落單與支付｜PinMe POS',
  faq: 'PinMe POS 常見問題｜香港餐廳掃碼落單、外賣整合、會員系統完整解答',
  about: '關於我們｜香港餐飲系統設計與營運團隊｜PinMe POS',
  'privacy-policy': '隱私政策｜個人資料與服務條款說明｜PinMe POS',
  'use-policy': '網站使用政策與免責聲明｜PinMe POS',
  getdemo: '免費獲取餐飲POS系統演示｜智慧餐廳 Demo｜PinMe POS',
  demoshow: '觀看餐飲POS系統演示｜咖啡廳、茶餐廳、米線店｜PinMe POS',
}
const description = {
  home: 'PinMe雲端餐飲Pos｜香港餐飲行業都在用的Pos系統，支持茶餐廳、拉麵或米線店、咖啡或茶飲店、西餐、酒樓、foodcourt等多種餐廳業態。提供專業的餐飲管理、餐廳電子流程管理、QR code落單、支持堂食、外賣、自取、餐飲會員系統、強大餐飲營銷工具、全面的餐飲數據報表，一部pos對接keeta、foodpanda、deliveroo等本地流行外賣平台。PinMe專注香港餐飲數碼化，提升餐廳營運效率。',
  snacks: '開咖啡店、茶飲店、快餐店、外賣店，就用PinMe餐飲Pos系統。簡單輕量，支持QR code落單，支持堂食/外賣/自取，支持流行的支付方式。一部pos對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。',
  restaurant: '開中式茶餐廳、冰室、西餐廳，就用PinMe餐飲Pos系統。支持複雜種類的電子餐單，豐富的菜式模型可選，支持qr code落單，支持堂食/外賣/自取，支持流行的支付方式。一部pos對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。',
  pasta: '開米線店、車仔麵、粉面類型餐廳，就用PinMe餐飲Pos系統。支持超級自由搭配的電子餐單模型，允許顧客根據餐廳的設置，靈活自由搭配，支持QR code落單，支持堂食/外賣/自取，支持流行的支付方式。一部pos對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。', 
  foodcourt: '開foodcourt就用pinme餐饮pos系统。支持“檔口收款”和“集中櫃台收款”，支持foodcourt的電子餐單功能、QR code落單。支持外賣配送、外賣自取業務，同時對接keeta、foodpanda、deliveroo等本地流行外賣平台。', 
  takeaway: '開虛擬餐廳/中央廚房，就用PinMe雲端餐飲Pos系統。提供強大的online餐廳主頁和電子餐單功能。支持外賣配送、外賣自取業務，同時對接keeta、foodpanda、deliveroo等本地流行外賣平台。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。',
  deliveryPlatform: 'PinMe雲餐餐飲pos｜一部pos管理所有外賣平台訂單，同時對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。支持菜單同步至外賣平台、訂單實時同步，集中處理，數據集中管理。',
  member: 'PinMe雲餐餐飲pos｜強大的會員管理CRM系統，支持會員歡迎券包、會員生日禮、會員價、會員印花累積與兌換功能。幫助餐廳留住老顧客，穩定提升餐廳的營業額。同時支持強大的會員數據分析功能，幫助餐廳發現最有價值的顧客，並留住顧客。同時也是獨立、專屬、安全的會員管理系統，數據隔離、信息安全。', 
  discount: 'PinMe雲餐餐飲pos｜強大的餐廳營銷模塊，支持豐富且可靈活配置的優惠券、兌換券、特價菜等營銷工具，幫助餐廳建立有效的營銷方案，並能合理控制促銷成本。', 
  systemKit: 'PinMe POS 系統功能模組完整介紹。主功能涵蓋智能POS終端、手機QR code落單、Wechat/Alipay小程式、門店支付結算、Keeta/Foodpanda外賣平台接駁、餐飲CRM會員系統、營銷優惠券工具及全套數據報表；輔助功能包括「等味」排隊取號、自助點餐Kiosk、取餐叫號大屏幕及ERP/硬件API接口。一站式了解PinMe如何全面提升香港餐廳營運效率。',
  queue: '排隊系統, 餐飲排隊, restaurant queuing system, 餐廳網上取號, 餐廳排號, 餐廳排隊大屏幕, 餐廳管理',
  bigScreen: '取餐大屏幕，餐品訂單製作狀態一目了然，全自動無需服務員操作，兩種大屏幕展示，支持堂食、自取、外賣平臺訂單',
  miniProgram: '餐廳Wechat小程式,Alipay小程式,免註冊,節省短信費用,適應大陸遊客習慣',
  newUi: 'PinMe推出"煥然一新"點餐手機界面，隨心定制界面，突出餐廳品牌個性。支持豐富廣告樣式，讓餐廳營銷更簡單。支持會員卡保存到Apple wallet、Google錢包。同時支持手機瀏覽器/wechat小程式/alipay小程式。',
  kiosk: 'PinMe 餐飲“自助點餐終端” KIOSK，節省人工，月月慳超過二萬蚊，一部機就搞掂！超清大屏，點餐操作更輕鬆！極速Kiosk落單體驗，支持優惠碼。',
  faq: '解答香港餐廳老闆選擇POS系統的常見問題，涵蓋掃碼落單、Foodpanda/Keeta整合、八達通支付、員工管理、會員系統及轉換成本，助你30分鐘內了解PinMe是否適合你的餐廳。',
  about: '認識 PinMe POS 的餐飲系統設計、產品營運與技術開發團隊，了解我們如何結合香港餐廳的日常運作習慣、雲端技術與會員營銷經驗，協助餐廳提升效率、降低成本及拓展生意。',
  'privacy-policy': '查閱 PinMe 網站的隱私政策及服務相關條款，了解個人資料的使用與儲存、訂購付款、取消安排、外部連結與責任限制等頁面說明。',
  'use-policy': '查閱 PinMe 網站使用政策，了解網站資訊的使用說明、內容與可用性聲明、外部網站連結及相關責任限制。',
  getdemo: '留下聯繫方式，免費獲取 PinMe 智慧餐廳系統演示。透過咖啡廳、茶餐廳及米線店三種場景，了解餐飲POS系統的操作與應用，探索適合門店的數碼化方案。',
  demoshow: '觀看 PinMe 智慧餐廳系統演示，選擇咖啡廳、茶餐廳或米線店 Demo，透過演示入口與二維碼體驗餐飲POS系統，了解不同餐廳場景的實際操作。',
}
const keywords = {
  home: `餐飲POS, 餐廳POS, 雲端POS,點餐POS, 餐飲業, 開餐廳, 茶餐廳POS, 奶茶店POS, 咖啡店POS, 酒樓POS, 西餐廳POS, POS軟體, 堂食點餐, 外賣店, 車仔麵, 火鍋店, 粉麵店, 飲品店, QR CODE 落單, 二維碼點餐, 自助點餐, 掃碼點餐, 手機落單, 自助落單, 二維碼落單, 外賣自取, 餐廳外賣, 餐廳外帶, 外帶系統, 外賣系統, 餐廳會員系統, 餐廳CRM系統, 香港餐飲`,
  snacks: '飲品店,咖啡店,快餐店,外賣店',
  restaurant: '茶餐廳,冰室,西餐,酒樓,中菜館',
  pasta: '車仔麵,米線店,中式粉面店',
  foodcourt: 'Foodcourt,餐飲大時代',
  takeaway: '雲端廚房,虛擬餐廳',
  deliveryPlatform: '外賣平台,Foodpanda,Deliveroo',
  member: '電子印花,優惠券,會員價',
  discount: '優惠券,折扣券,兌換券,特價菜',
  systemKit: 'PinMe POS功能, 餐飲POS系統, 智能POS終端, QR code落單, 手機點餐, 外賣平台整合, Keeta, Foodpanda, 餐廳會員系統, CRM, 優惠券, 數據報表, 自助點餐Kiosk, 排隊系統, 取餐大屏幕, 小程式點餐, 香港餐廳管理',
  queue: '餐廳排隊, 餐飲排隊系統, restaurant queuing system, 餐廳網上取號, 餐廳排號',
  bigScreen: '取餐大屏幕, 堂食、自取、外賣平臺大屏幕',
  miniProgram: '餐飲小程式,Wechat小程式,Alipay小程式',
  newUi: 'QR code落單, 掃碼落單, 電子菜單, 點餐系統',
  kiosk: 'KIOSK, 自助點餐, 點餐系統, KIOSK點餐',
  faq: 'PinMe POS 常見問題, 餐飲POS系統, 雲端POS, 掃碼落單, 外賣平台整合, 八達通支付, 餐廳會員系統',
  about: '關於PinMe, PinMe POS, 香港餐飲系統, 餐廳POS團隊, 餐飲系統開發',
  'privacy-policy': 'PinMe隱私政策, 個人資料, 資料使用, 服務條款, PinMe POS',
  'use-policy': 'PinMe使用政策, 網站免責聲明, 網站使用說明, 外部連結, PinMe POS',
  getdemo: 'PinMe Demo, 免費餐飲POS演示, 智慧餐廳演示, 餐廳系統體驗, 香港餐飲POS',
  demoshow: 'PinMe系統演示, 餐飲POS Demo, 咖啡廳POS, 茶餐廳POS, 米線店POS',
}
const schemas = {
  home: [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      'url': 'https://www.pin2eat.com/',
      'logo': 'https://www.pin2eat.com/img/icons/favicon-32x32.png'
    },
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      'name': 'PinMe POS',
      'applicationCategory': 'BusinessApplication',
      'operatingSystem': 'iOS, Android, Web',
      'description': '香港雲端餐廳POS系統，支援掃碼點餐、外賣整合、會員CRM'
    }
  ],
  snacks: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    'name': '飲品店、咖啡店、快餐店、外賣店pos系統',
    'applicationCategory': 'BusinessApplication',
    'operatingSystem': 'Web, Android, iOS',
    'image': 'https://spics.wantu.cn/922af80d805c8240b22afc76ea2d87e0.png',
    'description': '開咖啡店、茶飲店、快餐店、外賣店，就用PinMe餐飲Pos系統。簡單輕量，支持qr code落單，支持堂食/外賣/自取，支持流行的支付方式。一部pos對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。',
    'url': 'https://www.pin2eat.com/program/snacks',
    'publisher': {
      '@type': 'Organization',
      'name': 'PinMe'
    }
  },
  restaurant: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    'name': '茶餐廳/冰室/西餐廳/酒樓/中菜館pos系統',
    'applicationCategory': 'BusinessApplication',
    'operatingSystem': 'Web, Android, iOS',
    'image': 'https://spics.wantu.cn/922af80d805c8240b22afc76ea2d87e0.png',
    'description': '開中式茶餐廳、冰室、西餐廳，就用PinMe餐飲Pos系統。支持複雜種類的電子餐單，豐富的菜式模型可選，支持qr code落單，支持堂食/外賣/自取，支持流行的支付方式。一部pos對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。',
    'url': 'https://www.pin2eat.com/program/restaurant',
    'publisher': {
      '@type': 'Organization',
      'name': 'PinMe'
    }
  },
  pasta: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    'name': '車仔麵店/米線店/中式粉麵店pos系統',
    'applicationCategory': 'BusinessApplication',
    'operatingSystem': 'Web, Android, iOS',
    'image': 'https://spics.wantu.cn/922af80d805c8240b22afc76ea2d87e0.png',
    'description': '開米線店、車仔麵、粉面類型餐廳，就用PinMe餐飲Pos系統。支持超級自由搭配的電子餐單模型，允許顧客根據餐廳的設置，靈活自由搭配，支持qr code落單，支持堂食/外賣/自取，支持流行的支付方式。一部pos對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。',
    'url': 'https://www.pin2eat.com/program/pasta',
    'publisher': {
      '@type': 'Organization',
      'name': 'PinMe'
    }
  },
  foodcourt: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    'name': 'Foodcourt美食廣場pos系統',
    'applicationCategory': 'BusinessApplication',
    'operatingSystem': 'Web, Android, iOS',
    'image': 'https://spics.wantu.cn/922af80d805c8240b22afc76ea2d87e0.png',
    'description': '數碼化的Foodcourt營運，便於輕鬆管理每個舖位的音韻。支持QR code點餐，無需排隊。支持櫃面自取、自取外送等多種生意模式，提升交易額20%',
    'url': 'https://www.pin2eat.com/program/foodcourt',
    'publisher': {
      '@type': 'Organization',
      'name': 'PinMe'
    }
  },
  takeaway: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    'name': '中央廚房+外賣自取點/外賣送餐pos系統',
    'applicationCategory': 'BusinessApplication',
    'operatingSystem': 'Web, Android, iOS',
    'image': 'https://spics.wantu.cn/922af80d805c8240b22afc76ea2d87e0.png',
    'description': '開虛擬餐廳/中央廚房，就用PinMe雲端餐飲Pos系統。提供強大的online餐廳主頁和電子餐單功能。支持外賣配送、外賣自取業務，同時對接keeta、foodpanda、deliveroo等本地流行外賣平台。另可搭載餐飲會員CRM系統和營銷工具，吸引新顧客、留住老顧客。',
    'url': 'https://www.pin2eat.com/program/takeaway',
    'publisher': {
      '@type': 'Organization',
      'name': 'PinMe'
    }
  },
  deliveryPlatform: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': '一部POS管理所有外賣平臺訂單',
    'author': {
      '@type': 'Organization',
      'name': 'PinMe'
    },
    'datePublished': '2020-08-01',
    'description': 'PinMe雲餐餐飲pos｜一部pos管理所有外賣平台訂單，同時對接keeta、foodpanda、deliveroo等本地流行外賣平台，幫助餐廳提升營業額。支持菜單同步至外賣平台、訂單實時同步，集中處理，數據集中管理。'
  },
  member: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': '強大會員系統提升顧客的忠誠度',
    'author': {
      '@type': 'Organization',
      'name': 'PinMe'
    },
    'datePublished': '2020-08-01',
    'description': 'PinMe雲餐餐飲pos｜強大的會員管理CRM系統，支持會員歡迎券包、會員生日禮、會員價、會員印花累積與兌換功能。幫助餐廳留住老顧客，穩定提升餐廳的營業額。同時支持強大的會員數據分析功能，幫助餐廳發現最有價值的顧客，並留住顧客。同時也是獨立、專屬、安全的會員管理系統，數據隔離、信息安全。'
  },
  discount: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': '強大的營銷功能，幫助餐廳提升營業額',
    'author': {
      '@type': 'Organization',
      'name': 'PinMe'
    },
    'datePublished': '2020-08-01',
    'description': 'PinMe雲餐餐飲pos｜強大的餐廳營銷模塊，支持豐富且可靈活配置的優惠券、兌換券、特價菜等營銷工具，幫助餐廳建立有效的營銷方案，並能合理控制促銷成本。'
  },
  bigScreen: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': '取餐大屏幕，餐品訂單製作狀態一目了然',
    'author': {
      '@type': 'Organization',
      'name': 'PinMe'
    },
    'datePublished': '2025-02-06',
    'description': '取餐大屏幕，餐品訂單製作狀態一目了然，全自動無需服務員操作，兩種大屏幕展示，支持堂食、自取、外賣平臺訂單'
  },
  miniProgram: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': '免費升級餐飲小程式',
    'author': {
      '@type': 'Organization',
      'name': 'PinMe'
    },
    'datePublished': '2025-02-06',
    'description': '餐廳Wechat小程式,Alipay小程式,免註冊,節省短信費用,適應大陸遊客習慣',
  },
  newUi: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': '"煥然一新"點餐手機界面',
    'author': {
      '@type': 'Organization',
      'name': 'PinMe'
    },
    'datePublished': '2025-04-21',
    'description': 'PinMe推出"煥然一新"點餐手機界面，隨心定制界面，突出餐廳品牌個性。支持豐富廣告樣式，讓餐廳營銷更簡單。支持會員卡保存到Apple wallet、Google錢包。同時支持手機瀏覽器/wechat小程式/alipay小程式。'
  },
  kiosk: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': 'PinMe自助點餐Kiosk，無人自助點餐機，少請一個人，月月慳超過二萬蚊！',
    'author': {
      '@type': 'Organization',
      'name': 'PinMe'
    },
    'datePublished': '2025-08-11',
    'description': 'PinMe 餐飲“自助點餐終端” KIOSK，節省人工，月月慳超過二萬蚊，一部機就搞掂！超清大屏，點餐操作更輕鬆！極速Kiosk落單體驗，支持優惠碼。',
  },
  queue: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    'name': '等味排隊',
    'image': 'https://spics.wantu.cn/922af80d805c8240b22afc76ea2d87e0.png',
    'description': '排隊系統, 餐飲排隊, restaurant queuing system, 餐廳網上取號, 餐廳排號, 餐廳排隊大屏幕, 餐廳管理',
    'brand': {
      '@type': 'Brand',
      'name': 'PinMe'
    }
  },
  systemKit: [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      'name': 'PinMe POS 系統功能模組完整介紹',
      'description': 'PinMe POS 系統功能模組完整介紹，主功能涵蓋智能POS終端、手機QR code落單、Wechat/Alipay小程式、門店支付結算、Keeta/Foodpanda外賣平台接駁、餐飲CRM會員系統、營銷優惠券工具及全套數據報表；輔助功能包括「等味」排隊取號、自助點餐Kiosk、取餐叫號大屏幕及ERP/硬件API接口。',
      'url': 'https://www.pin2eat.com/system-kit',
      'publisher': {
        '@type': 'Organization',
        'name': 'PinMe',
        'logo': {
          '@type': 'ImageObject',
          'url': 'https://www.pin2eat.com/img/icons/favicon-32x32.png'
        }
      }
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      'name': 'PinMe POS 功能模組列表',
      'description': 'PinMe POS 系統全套功能模組',
      'url': 'https://www.pin2eat.com/system-kit',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'name': '智能POS終端',
          'description': '香港餐廳智能POS點餐終端，支援堂食、外賣、自取多種業務模式'
        },
        {
          '@type': 'ListItem',
          'position': 2,
          'name': '手機QR Code落單',
          'description': '顧客掃碼自助落單，支援Wechat/Alipay小程式及手機瀏覽器'
        },
        {
          '@type': 'ListItem',
          'position': 3,
          'name': '外賣平台整合',
          'description': '一部POS同時接駁Keeta、Foodpanda、Deliveroo等外賣平台'
        },
        {
          '@type': 'ListItem',
          'position': 4,
          'name': '餐飲CRM會員系統',
          'description': '電子印花、優惠券、會員價、生日禮等完整會員管理功能'
        },
        {
          '@type': 'ListItem',
          'position': 5,
          'name': '自助點餐Kiosk',
          'description': '無人自助點餐終端，節省人工成本，支援多種支付方式'
        },
        {
          '@type': 'ListItem',
          'position': 6,
          'name': '排隊取號系統',
          'description': '「等味」餐廳排隊系統，支援線上取號及預點單功能'
        },
        {
          '@type': 'ListItem',
          'position': 7,
          'name': '取餐叫號大屏幕',
          'description': '餐品製作狀態大屏幕展示，支援粵語/英語/普通話三語叫號'
        },
        {
          '@type': 'ListItem',
          'position': 8,
          'name': '數據報表',
          'description': '全套餐廳營運數據報表，支援多門店集中管理'
        }
      ]
    }
  ],
  faq: createFaqPageSchema(
    filterFaqGroupsByScene(
      faqData as unknown as FaqData,
      FAQ_SCENES.FAQ,
    ),
  ),
  about: {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: titles.about,
    description: description.about,
    url: 'https://www.pin2eat.com/about',
    inLanguage: 'zh-HK',
    about: { '@type': 'Organization', name: 'PinMe', url: 'https://www.pin2eat.com/' },
  },
  'privacy-policy': {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: titles['privacy-policy'],
    description: description['privacy-policy'],
    url: 'https://www.pin2eat.com/privacy-policy',
    inLanguage: 'zh-HK',
  },
  'use-policy': {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: titles['use-policy'],
    description: description['use-policy'],
    url: 'https://www.pin2eat.com/use-policy',
    inLanguage: 'zh-HK',
  },
  getdemo: {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: titles.getdemo,
    description: description.getdemo,
    url: 'https://www.pin2eat.com/getdemo',
    inLanguage: 'zh-HK',
  },
  demoshow: {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: titles.demoshow,
    description: description.demoshow,
    url: 'https://www.pin2eat.com/demoshow',
    inLanguage: 'zh-HK',
  },
}

const restaurantSocialMgmTitle = '餐廳社交分享及裂變增長｜雙向獎勵、MGM活動管理與數據分析｜PinMe POS 香港餐飲一站式營銷系統'
const restaurantSocialMgmDescription = 'PinMe POS 餐廳社交分享功能，支援 WhatsApp、微信及邀請連結多渠道觸達，配合分享人與受邀人的雙向獎勵、品牌活動後台、活動落地頁及數據儀表板，協助香港餐廳追蹤分享率、邀請轉換率、首單率、裂變係數與獎勵成本，靈活控制推廣預算，以社交裂變持續吸引新客戶並提升會員轉換與營運效率，建立可持續的低成本獲客循環。'
const restaurantSocialMgmKeywords = '餐廳社交分享, 社交裂變, 雙向獎勵, PinMe POS, MGM活動, 餐廳會員營銷, 香港餐飲'
const restaurantSocialMgmCanonicalUrl = 'https://www.pin2eat.com/sale/restaurant-social-mgm'
const restaurantSocialMgmSocialImage = 'https://spics.inctrip.com/a82a1eda4df6f01fd234bb125ec8fa0f.png'
const defaultSocialImage = 'https://spics.inctrip.com/feeb37f9b8c30eb01e01b5a2944a4aa7.jpg'

Object.assign(titles, {
  googleWallet: 'Google Wallet 推廣｜電子會員卡、優惠券與到店提醒｜PinMe POS',
  shareCoupons: '開放領券｜多渠道派券與快捷登入｜PinMe POS',
  restaurantSocialMgm: restaurantSocialMgmTitle,
})
Object.assign(description, {
  googleWallet: 'PinMe Google Wallet 推廣，整合電子會員卡、優惠憑證、增值跳轉入口及到店提醒，協助餐廳觸達會員、推廣優惠及追蹤營銷成效。',
  shareCoupons: '顧客主動轉發優惠券包，拉新客、吸引老客戶進店消費。支援多渠道派券、五種快捷登入、點餐彈窗及品牌後台活動管理。',
  restaurantSocialMgm: restaurantSocialMgmDescription,
})
Object.assign(keywords, {
  googleWallet: 'Google Wallet, 電子會員卡, 餐廳優惠券, 到店提醒, 餐飲CRM, PinMe POS',
  shareCoupons: '開放領券, 餐廳優惠券, PinMe POS',
  restaurantSocialMgm: restaurantSocialMgmKeywords,
})
Object.assign(schemas, {
  googleWallet: [{ '@context': 'https://schema.org', '@type': 'WebPage', name: 'Google Wallet 推廣｜電子會員卡、優惠券與到店提醒｜PinMe POS', description: 'PinMe Google Wallet 推廣，整合電子會員卡、優惠憑證、增值跳轉入口及到店提醒，協助餐廳觸達會員、推廣優惠及追蹤營銷成效。', url: 'https://www.pin2eat.com/sale/google-wallet' }, createFaqPageSchema(filterFaqGroupsByScene(faqData as FaqData, FAQ_SCENES.GOOGLE_WALLET))],
  shareCoupons: createFaqPageSchema(filterFaqGroupsByScene(faqData as FaqData, FAQ_SCENES.SHARE_COUPONS)),
  restaurantSocialMgm: [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      'name': 'PinMe POS 餐廳社交分享與裂變增長',
      'description': restaurantSocialMgmDescription,
      'url': restaurantSocialMgmCanonicalUrl,
    },
    createFaqPageSchema(
      filterFaqGroupsByScene(
        faqData as unknown as FaqData,
        FAQ_SCENES.RESTAURANT_SOCIAL_MGM,
      ),
    ),
  ],
})

const canonicalUrls = {
  googleWallet: 'https://www.pin2eat.com/sale/google-wallet',
  restaurantSocialMgm: restaurantSocialMgmCanonicalUrl,
}
const socialImages = {
  googleWallet: 'https://spics.inctrip.com/5109086ce5c9954ff70aaf7363216faf.png',
  shareCoupons: 'https://spics.inctrip.com/c1ff2ad158d70b8ebf86d2f60a69368d.png',
  restaurantSocialMgm: restaurantSocialMgmSocialImage,
}

router.beforeEach((to, from, next) => {
  const currentTitle = titles[to.name] || titles['home']
  const currentDescription = description[to.name] || description['home']
  const currentKeywords = keywords[to.name] || keywords['home']
  const canonicalUrl = canonicalUrls[to.name] || `https://www.pin2eat.com${to.path}`
  const socialImage = socialImages[to.name] || defaultSocialImage

  document.title = currentTitle
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.setAttribute('content', currentDescription)
  }
  const metaKeywords = document.querySelector('meta[name="keywords"]')
  if (metaKeywords) {
    metaKeywords.setAttribute('content', currentKeywords)
  }
  // 2024 seo
  // schema
  const schemaTag = document.querySelector('#schema-tag')
  if (schemaTag) {
    const schemaData = schemas[to.name] || schemas['home']
    schemaTag.innerHTML = JSON.stringify(Array.isArray(schemaData) ? schemaData : schemaData)
  }
  // canonical
  const rel = document.querySelector('link[rel="canonical"]')
  if (rel) {
    rel.setAttribute('href', canonicalUrl)
  }
  // og type
  const ogType = document.querySelector('meta[property="og:type"]')
  if (ogType) {
    ogType.setAttribute('content', 'website')
  }
  // og title
  const ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle) {
    ogTitle.setAttribute('content', currentTitle)
  }
  // og description
  const ogDescription = document.querySelector('meta[property="og:description"]')
  if (ogDescription) {
    ogDescription.setAttribute('content', currentDescription)
  }
  // og url
  const ogUrl = document.querySelector('meta[property="og:url"]')
  if (ogUrl) {
    ogUrl.setAttribute('content', canonicalUrl)
  }
  // og image
  const ogImage = document.querySelector('meta[property="og:image"]')
  if (ogImage) {
    ogImage.setAttribute('content', socialImage)
  }
  // twitter card
  const twCard = document.querySelector('meta[name="twitter:card"]')
  if (twCard) {
    twCard.setAttribute('content', 'summary_large_image')
  }
  // twitter title
  const twTitle = document.querySelector('meta[name="twitter:title"]')
  if (twTitle) {
    twTitle.setAttribute('content', currentTitle)
  }
  // twitter description
  const twDescription = document.querySelector('meta[name="twitter:description"]')
  if (twDescription) {
    twDescription.setAttribute('content', currentDescription)
  }
  // twitter url
  const twUrl = document.querySelector('meta[name="twitter:url"]')
  if (twUrl) {
    twUrl.setAttribute('content', canonicalUrl)
  }
  // twitter image
  const twImage = document.querySelector('meta[name="twitter:image"]')
  if (twImage) {
    twImage.setAttribute('content', socialImage)
  }

  next()
})

export default router
